import { render, staticRenderFns } from "./ShareSolicCotacao.vue?vue&type=template&id=7ccd8af0&"
import script from "./ShareSolicCotacao.vue?vue&type=script&lang=js&"
export * from "./ShareSolicCotacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports